/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcOrdersV1BatchOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_ORDERS_V1_BATCH_ORDER_EVENT_ENTITY_NAME = 'ixc.orders.v1.BatchOrderEvent';
export const ixcOrdersV1BatchOrderEventEntity = new schema.Entity<IxcOrdersV1BatchOrderEvent>(IXC_ORDERS_V1_BATCH_ORDER_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        quoteReceived: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcOrdersV1BatchOrderEvent) => `${entity.metadata?.eventId}` });

